/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import { Spacings } from '../../../styleConstants';

const StyledProgress = styled(LinearProgress)`
  &.MuiLinearProgress-root {
    height: ${Spacings.SPACING_1B};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    width: ${({ width }) => width};
    align-self: center;
    border-radius: ${({ $borderRadius }) => $borderRadius};
  }
  &.MuiLinearProgress-root .MuiLinearProgress-bar {
    border-radius: ${({ borderRadius }) => borderRadius};
    background-color: ${({ $overlayColor }) => $overlayColor};
  }
`;

const LinearProgressBar = ({
  value,
  width,
  borderRadius,
  backgroundColor,
  overlayColor,
  className,
  onMouseOver,
  onMouseOut
}) => {
  const progress = value > 100 ? 100 : value;
  const theme = useContext(ThemeContext);
  return (
    <StyledProgress
      variant="determinate"
      value={progress}
      width={width}
      $borderRadius={borderRadius}
      $backgroundColor={backgroundColor || theme.colors.dropShadowV2}
      $overlayColor={overlayColor}
      className={className}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    />
  );
};

export default LinearProgressBar;

LinearProgressBar.propTypes = {
  value: PropTypes.number,
  width: PropTypes.string,
  borderRadius: PropTypes.string,
  backgroundColor: PropTypes.string,
  overlayColor: PropTypes.string,
  className: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func
};

LinearProgressBar.defaultProps = {
  width: '105px',
  borderRadius: Spacings.SPACING_5B,
  backgroundColor: '#f0f4f7',
  overlayColor: '#08bd80',
  className: '',
  onMouseOver: null,
  value: 0,
  onMouseOut: () => {}
};
